import { get, postJsonAdmin } from './_core.js';

export interface JobStatsRow {
  jobName: string;
  total: number;
  errors: number;
  errorRate: number;
  p50Ms: number | null;
  p95Ms: number | null;
  lastRunIso: string | null;
}

export interface JobsResponse {
  since: string;
  queueDepth: Record<string, Record<string, number>>;
  jobs: JobStatsRow[];
}

export async function fetchJobs(): Promise<JobsResponse> {
  const res = await get<JobsResponse>('/admin/jobs');
  return res.data;
}

// ─── BO-5 A.8 — Job frequency-spark ──────────────────────────────────────

export interface JobSparkBucket {
  hour: string;
  runs: number;
  errors: number;
}

export async function fetchJobFrequencySpark(
  jobName: string,
): Promise<{ buckets: JobSparkBucket[] }> {
  const res = await get<{ buckets: JobSparkBucket[] }>(
    `/admin/jobs/${encodeURIComponent(jobName)}/frequency-spark`,
  );
  return res.data;
}

// ─── BO-5 C.5–C.7 — mutations ────────────────────────────────────────────

export async function pauseJob(
  jobName: string,
  reason?: string,
): Promise<{ jobName: string; pausedAt: string }> {
  return postJsonAdmin(`/admin/jobs/${encodeURIComponent(jobName)}/pause`, reason ? { reason } : {});
}

export async function resumeJob(jobName: string): Promise<{ jobName: string }> {
  return postJsonAdmin(`/admin/jobs/${encodeURIComponent(jobName)}/resume`, {});
}

export async function drainJob(
  jobName: string,
): Promise<{ jobName: string; affectedCount: number }> {
  return postJsonAdmin(`/admin/jobs/${encodeURIComponent(jobName)}/drain`, {});
}

export async function retryFailedJob(
  jobName: string,
): Promise<{ jobName: string; affectedCount: number }> {
  return postJsonAdmin(`/admin/jobs/${encodeURIComponent(jobName)}/retry-failed`, {});
}
